export enum ApplicationMode {
    Default = 'default',
    Draft = 'draft',
}
